import { render, staticRenderFns } from "./catalogInit.vue?vue&type=template&id=9d445888&scoped=true&lang=pug"
import script from "./catalogInit.vue?vue&type=script&lang=js"
export * from "./catalogInit.vue?vue&type=script&lang=js"
import style0 from "./catalogInit.vue?vue&type=style&index=0&id=9d445888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d445888",
  null
  
)

export default component.exports